'use client';

import type { ReactNode } from 'react';
export function SessionGuard({
  children
}: {
  children: ReactNode;
}) {
  // const { data } = useSession();
  // useEffect(() => {
  //   if (data?.error === 'RefreshAccessTokenError') {
  //     console.log('needs refreshing');
  //     signIn('keycloak');
  //   }
  // }, [data]);

  return <div data-sentry-component="SessionGuard" data-sentry-source-file="session-guard.tsx">{children}</div>;
}